// label: value
const INTERNAL_NOTE_TYPES = {
  platformPerson: 'PlatformPerson',
  platformOrganization: 'PlatformOrganization',
  ds1Person: 'Ds1::Person',
}

export default INTERNAL_NOTE_TYPES
